import React from 'react';
import DOMPurify from 'dompurify';
import { Card, Container, Dropdown, Form, DropdownButton, Button,  Accordion, Row, Col } from 'react-bootstrap';
import { FaBook , FaBlog, FaSearch, FaEdit, FaCheck, FaTags, FaExpandArrowsAlt} from 'react-icons/fa';

import classes from './Blog.css';

const createMarkup = (html) => {
    return  {
      __html: DOMPurify.sanitize(html)
    }
  }

  
const blog = ( props ) => {
    let borderColor = props.complete ? "black" : "lightgray";
    var data = props.data;
    let statusIcon = props.complete ? <FaCheck /> : <FaEdit />;

    return (

      // <div className={classes.Blog} style={{border:'0px solid '+borderColor}}>
      <div>
      <Accordion defaultActiveKey="0" className={classes.Blog}  style={{border:'1px solid '+borderColor}}>
      <span style={{padding:'0px 30px 0px 5px',alignItems:"left", alignText:"left", width:'100%', fontWeight:'bold'}}><FaTags/> {props.blogTags} </span><br></br>
      <Accordion.Collapse eventKey="0">
      <div style={{paddingTop:"10px"}}>
        <div style={{width:"100%"}}>
          <div style={{float:'left'}}>
            <span style={{padding:'0px 30px 0px 10px', float:'inline-start', width:'100%', fontWeight:'bold'}}><button className="btn btn-secondary px-4" onClick={() => props.handleBlogClicked(props.blogText)} style={{fontSize:"15px", backgroundColor:'#042a4a'}}>Expand</button></span>
            {props.showButton ? 
            <span style={{padding:'0px 30px 0px 10px', float:'inline-start', width:'100%', fontWeight:'bold'}}><button className="btn btn-secondary px-4" onClick={()=>props.editBlog(data)} style={{fontSize:"15px", backgroundColor:'#042a4a'}}>Edit</button></span>
             : ''}
            <br></br><br></br>
          </div>
        </div>

        <div style={{width:'100%'}} className={classes.editordiv} dangerouslySetInnerHTML={createMarkup(props.blogText)}></div>

      </div>
      </Accordion.Collapse>
      </Accordion>
      <br></br><br></br>
      </div>





        // <div className={classes.Blog} style={{border:'1px solid '+borderColor}}>
        //     <p>Book: <strong>{props.title}</strong></p>
        //     <p>Blogger: <strong>{props.userName}</strong></p>
        //     <p>BLOG Title: <strong>{props.blogTitle}</strong></p>
        //     <p>BLOG Tags: <strong>{props.blogTags}</strong></p>
        //     <p>Status: <strong>{props.complete ? "Complete" : "Incomplete"}</strong></p>
        //     {props.showButton ? 
        //       <button className="btn btn-secondary px-4" onClick={()=>props.editBlog(data)} style={{fontSize:"15px", backgroundColor:'#042a4a'}}>Edit BLOG</button>
        //     : ''}
        //     <br></br><br></br>

        //     <div className={classes.editordiv} dangerouslySetInnerHTML={createMarkup(props.blogText)}></div>

        //     {/* <p>{props.blogText}</p> */}
        // </div>


    );
};

export default blog;


// WEBPACK FOOTER //
// ./src/components/Blog/Blog.js